import { render, staticRenderFns } from "./PartnerFeedback.vue?vue&type=template&id=e95017e2&"
import script from "./PartnerFeedback.vue?vue&type=script&lang=js&"
export * from "./PartnerFeedback.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports